import { useCalculator } from 'contexts/Calculator/Calculator';
import { useTooltip } from 'contexts/Tooltip/Tooltip';

export default function PopulationSizeError() {

    const calculator = useCalculator();
    const tooltip = useTooltip();

    function handleFill() {
        calculator.setPopulationSize(330000000);
        handleFocus();
    }

    function handleFocus() {
        tooltip.hide();
        document.querySelector<HTMLInputElement>("[id$='populationSize']")?.focus();
    }

    return (
        <>
            <h5 className="text-error">NOTE</h5>
            <p>
                You have not entered a <b>Population size</b> at the top of the page. This is necessary to calculate your variant.
                <br />
                <br />
                <button
                    className="btn-link"
                    data-testid="setup-use-us-population"
                    onClick={handleFill}
                    type="button"
                >
                    Use 330,000,000
                </button>{' '}
                <span className="fst-italic text-accent">(Population of the US)</span>
                <br />
                <br />
                or
                <br />
                <br />
                <button className="btn-link" onClick={handleFocus} type="button">
                    Add your value
                </button>
            </p>
        </>
    );

}